import React, { useState } from 'react';
import styles from './ProductHero.module.scss';
import { classNameGenerator, clsx } from '@/utils';
import { useAppSelector, useWindowDimensions } from '@/hooks';
import { useRouter } from 'next/router';

const ProductHero = () => {
    const cls = classNameGenerator(styles);
    const router = useRouter();
    const { data } = useAppSelector((state) => state.healthProgramV1);
    const {width} = useWindowDimensions()
    if (!data?.productHero) {
        return <></>
    }

    const { tabContent, features } = data?.productHero || {}

    const tabs = Object.keys(tabContent);
    const [activeTab, setActiveTab] = useState(tabs[0]);

    // 2. Extract current content based on state
    const current = tabContent[activeTab];
    const bgImage = width > 600 ? current.bgImage : current.mobImage
    const isFirstTab = activeTab === tabs[0];
    const onClickHandler = (link : string) => {
        router.push(link)
    }
    return (
        <div className={cls("product-page-container")} onClick={()=>{onClickHandler(current?.link)}}>
            <section
                className={cls("hero-section")}
                style={{
                    backgroundImage: `
                    url(${bgImage})
                    `,
                }}
            >
                <div className={clsx(cls("hero-overlay"), isFirstTab ? cls("first-tab-active") : '')}>
                    <nav className={cls("tab-navigation")}>
                        {tabs.map((tab) => (
                            <button
                                key={tab}
                                className={activeTab === tab ? cls("active") : ''}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveTab(tab)
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </nav>

                    <div className={cls("hero-content")}>
                        <h1>{current.title}</h1>
                        <p className={cls("hero-description")}>{current.description}</p>
                        <div className={cls("stats-container")}>
                            {current.stats.map((stat, i) => (
                                <div key={i} className={cls("stat-item")}>
                                    <span className={cls("stat-value")}>{stat.value}</span>
                                    <span className={cls("stat-label")}>{stat.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className={cls("features-bar")}>
                {features.map((f, i) => (
                    <div key={i} className={cls("feature-item")}>
                        <img src={f.icon} alt={f.label} className={cls("feature-icon")} />
                        <span className={cls("feature-label")}>{f.label}</span>
                    </div>
                ))}
            </section>

            <section className={cls("philosophy-section")}>
                <span className={cls("overline")}>OUR PHILOSOPHY</span>
                <h2>Our approach is simple - <strong>do more with less.</strong></h2>
                <p className={cls("philosophy-text")}>
                    We focus on what works, remove what doesn't, and stay transparent every step of the way.
                </p>
                <p className={cls("philosophy-text")}>
                    Built for those who expect more from what they consume."
                </p>
            </section>
        </div>
    );
};

export default ProductHero;